// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__PTN8B","button":"styles_button__3yJBl"};